import { Deposit } from "@assets/svg";
import { useStyles } from "@components/Modals/BankRelinkModal/styles";
import { Body, Caption } from "@components/Typography";
import { useFailedAchContribution, useTheme } from "@hooks";
import { i18n, Translations } from "@i18n";
import { convertCentsToDollar, formatCurrency } from "@utils/formatter";

export const RecurringContributionItem = () => {
  const styles = useStyles();
  const { theme } = useTheme();
  const { failedTransaction } = useFailedAchContribution();
  const beneficiaryName = failedTransaction?.beneficiaryName;
  const amountInCents = failedTransaction?.amountInCents;

  if (!beneficiaryName || amountInCents == null) {
    return null;
  }

  const amount = formatCurrency(convertCentsToDollar(amountInCents), true);

  return (
    <div style={styles.recurringContributionContainer}>
      <div style={styles.recurringContributionIcon}>
        <Deposit fill={theme.relink.recurring.icon.fill} />
      </div>

      <div style={styles.recurringContributionContent}>
        <Body style={styles.recurringContributionTitle}>
          {i18n.t(Translations.BankRelinkModalContributionTitle)}
        </Body>
        <div style={styles.badge}>
          <Caption style={styles.badgeText}>{beneficiaryName}</Caption>
        </div>
      </div>

      <Body style={styles.amount}>{amount}</Body>
    </div>
  );
};
